export const editMutations = <const>{
	PRACOVNI_POZICE_PPNR_SELECT_MAPPER: 'PRACOVNI_POZICE_PPNR_SELECT_MAPPER',
};
